import { createContext } from 'react'

export type Theme = 'light' | 'dark'

export type ThemeApi = {
  theme: Theme
  setTheme: (newTheme: Theme) => void
}

export const ThemeContext = createContext<ThemeApi>({
  theme: 'light',
  setTheme: () => undefined,
})
